import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export function useAddCandidateRole() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, role }) => {
      return axios.post(`/candidate/${candidate.uuid}/role`, role);
    },
    onSuccess: (data, variables) => {
      client.setQueryData(
        ["candidateDetails", variables.candidate.uuid],
        data.data
      );
    },
  });
}

export function useUpdateCandidateRole() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, role }) => {
      const formData = new FormData();
      for (const [key, val] of Object.entries(role)) {
        formData.append(key, val);
      }
      // if a new image is uploaded (image_data), remove the image url (image)
      if (formData.has("image_data")) {
        formData.delete("image");
      }
      // if image_data is null, remove it
      if (formData.get("image_data") === "null") {
        formData.delete("image_data");
      }
      formData.append("_method", "PATCH"); // Laravel will treat this as a PATCH request

      return axios.post(
        `/candidate/${candidate.uuid}/role/${role.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.candidate.uuid], data);
    },
  });
}

export function useRemoveCandidateRole() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, roleId }) => {
      return axios.delete(`/candidate/${candidate.uuid}/role/${roleId}`);
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.candidate.uuid], data);
    },
  });
}

export function useReorderCandidateRoles() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, order }) => {
      return axios.post(`/candidate/${candidate.uuid}/roles/reorder`, {
        order,
      });
    },
    onSuccess: (data, variables) => {
      client.setQueryData(
        ["candidateDetails", variables.candidate.uuid],
        data
      );
    },
  });
}
